import { logEvent } from '@amplitude/analytics-browser';
import { onCLS, onINP, onLCP } from 'web-vitals';

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

onCLS(metric => logEvent('CLS', metric));
onINP(metric => logEvent('INP', metric));
onLCP(metric => logEvent('LCP', metric));
